// apps/lc/src/mocks/wireframe/lessons.ts
import type { LessonRecord } from './types'
import { STUDENTS } from './students'
import { ENROLLMENTS } from './enrollments'
import { daysAgo } from './dateUtils'

// generate 6 most-recent sessions for each active enrollment
export const LESSON_RECORDS: LessonRecord[] = ENROLLMENTS.filter(e => e.status === 'active').flatMap(e => {
  const s = STUDENTS.find(st => st.id === e.studentId)
  if (!s) return []
  return [0, 2, 4, 7, 9, 12].map((d, idx) => {
    const date = daysAgo(d).toISOString().slice(0, 10)
    const accuracy = 60 + ((idx * 7 + e.id.charCodeAt(2)) % 35)
    return {
      id: `lr-${e.id}-${idx}`,
      studentId: s.id,
      enrollmentId: e.id,
      sessionNumber: 30 - idx,
      date,
      status: '완료' as const,
      chapterNumber: ((idx + 1) % 5) + 1,
      chapterTitle: e.currentChapterTitle,
      lessonNumber: (idx % 6) + 1,
      lessonTitle: `${e.curriculum.toUpperCase()} 레슨 ${(idx % 6) + 1}`,
      accuracy,
      solvedCount: 10,
      wrongCount: Math.max(0, Math.round((100 - accuracy) / 10)),
    }
  })
})
